__turbopack_context__.v({
  "btnSaveCont": "PersonalIdentificationDocument-module-scss-module__Z_JB8W__btnSaveCont",
  "identity-inputs-wrapper": "PersonalIdentificationDocument-module-scss-module__Z_JB8W__identity-inputs-wrapper",
  "identity-left": "PersonalIdentificationDocument-module-scss-module__Z_JB8W__identity-left",
  "isSaved": "PersonalIdentificationDocument-module-scss-module__Z_JB8W__isSaved",
  "wrapper": "PersonalIdentificationDocument-module-scss-module__Z_JB8W__wrapper",
});
